
import { IInsuranceQuestionnaireState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import { onNgrxForms, onNgrxFormsAction, SetValueAction, createFormGroupState, updateGroup, validate, wrapReducerWithFormStateUpdate } from 'ngrx-forms';
import { requiredTrue } from 'ngrx-forms/validation';
import { QuestionnaireWordingResponseAction, ShowQuestionnaireResponseAction } from './actions';
import { InsuranceRequestModel } from 'src/app/model/insurance-questionnaire.model';

export const formName = 'insuranceRequestForm';

export const validateInsuranceRequestForm = updateGroup<InsuranceRequestModel>({
  confirmReadInsuranceRequestInsuranceGuide: validate(requiredTrue),
});

export const state: IInsuranceQuestionnaireState = {
  form: createFormGroupState(formName, new InsuranceRequestModel()),
  ageNextBirthday:0,
  showQuestionnaire: false,
  elegibilityDate: null,
  wording: null
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ShowQuestionnaireResponseAction, (state, { payload }) => {
    return {
      ...state,
      form: createFormGroupState(formName, new InsuranceRequestModel()),
      showQuestionnaire: payload.show,
      elegibilityDate: payload.offerExpiryDate,
      ageNextBirthday: payload.ageNextBirthday
    };
  }),
  on(QuestionnaireWordingResponseAction, (state, {wording}) => {
    return {
      ...state,
      wording
    }
  })
);

export function insuranceQuestionnaireReducer(state: any | undefined, action: Action) {
  return editInsuranceRequestReducerFormState(state, action);
}

const editInsuranceRequestReducerFormState = wrapReducerWithFormStateUpdate(
  reducer,
  s => s.form,
  validateInsuranceRequestForm,
);

